import React from "react";
import "../../styles/WhatWeDoStyles.css";

const WhatWeDo = () => {
  const services = [
    {
      icon: `${process.env.PUBLIC_URL}/images/icons/arqui.png`,
      title: "Arquitectura",
      description:
        "Planificamos y diseñamos espacios funcionales y estéticos adaptados a tus necesidades.",
    },
    {
      icon: `${process.env.PUBLIC_URL}/images/icons/deco.png`,
      title: "Diseño Interior",
      description:
        "Creamos experiencias únicas en espacios interiores que reflejan tu estilo.",
    },
    {
      icon: `${process.env.PUBLIC_URL}/images/icons/diseño.png`,
      title: "Mobiliario",
      description:
        "Diseñamos muebles personalizados que combinan funcionalidad y elegancia.",
    },
    {
      icon: `${process.env.PUBLIC_URL}/images/icons/consulta.png`,
      title: "Consultoría",
      description:
        "Ofrecemos asesorías especializadas para que lleves tus proyectos al siguiente nivel.",
    },
  ];

  return (
    <section className="what-we-do-section">
      <div className="what-we-do-header text-start">
        <h3>Qué hacemos</h3>
        <h2>OFRECEMOS LOS MEJORES SERVICIOS</h2>
      </div>
      <div className="what-we-do-content">
        {services.map((service, index) => (
          <div key={index} className="what-we-do-item">
            <img src={service.icon} alt={service.title} className="service-icon" />
            <h4>{service.title}</h4>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhatWeDo;
